export const ParameterType = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    MULTI_VALUE: 'MULTI_VALUE',

    values: () => {
        return ['STRING', 'NUMBER', 'MULTI_VALUE'];
    }
}